<template>
  <HoverTooltip>
    <template #subject>
      <div
        class="text-gray-700 bg-gray-100 hover:text-white hover:bg-orange-300 transition duration-150 ease-in-out px-7px md:px-2 py-1 rounded-full cursor-pointer ds-text-sm md:ds-text-base"
        data-test-id="favorite-cta"
        @click="onSkip"
      >
        <Icon name="eye-slashed" />
      </div>
    </template>
    <template #tooltip>
      Skip this athlete
    </template>
  </HoverTooltip>
</template>

<script>
import { defineComponent } from 'vue'
import { Icon, HoverTooltip } from "@sportsrecruits/playbook";
import { mapActions } from "vuex";

export default defineComponent({
  name: "SkipButton",
  components: { Icon, HoverTooltip },
  methods: {
    ...mapActions('athleteProfile', ['skip']),
    async onSkip() {
      await this.skip();
      this.$emit('skipped', this.athlete)
    },
  },
})
</script>

<style scoped>
.px-7px {
  padding-left: 7px;
  padding-right: 7px;
}
</style>